<template>
  <div class="PlaceOrderMultiple-root">
    <div v-if="showCreditTips" class="credit-content">
      <a-alert class="credit-tips" closable show-icon :type="creditType">
        <a-icon slot="icon" theme="filled" type="info-circle" />
        <marquee slot="message" style="width: 230px">
          {{ creditMessage }}
        </marquee>
      </a-alert>
    </div>
    <a-form-model
      ref="ruleForm"
      :model="queryForm"
      layout="horizontal"
      :label-col="{ span: 8 }"
      :wrapper-col="{ span: 16 }"
      class="query_form"
    >
    <ul class="operation-list">
      <!-- 非标产品导入 -->
      <a-tabs :active-key="active" type="card" class="tabs-card" @change="changeTab">
        <a-tab-pane key="1" tab="标准模板导入">
            <div v-if="isEnterprise" class="query_form_item">
              <a-form-model-item
                :rules="[{ required: true, message: '请选择服务商', trigger: 'change' }]"
                label="服务商"
                prop="tenantId"
              >
                <serviceSelect
                  :value="selectCarrier"
                  :is-default-select="true"
                  @change="handleChange"
                ></serviceSelect>
              </a-form-model-item>
            </div>
          <component
            :is="getComponent"
            :is-wms-system="isWmsSystem"
            :type-index="typeIndex"
            :product-list="productList"
            :non-operating="nonOperating"
            :has-warehouse-contract="hasWarehouseContract"
            :is-discharge="isDischarge"
            :is-sea-shipping="isSeaShipping"
            :is-supplementary="isSupplementary"
            :is-settlement="isSettlement"
            @editTypeIndex="editTypeIndex"
            @downloadExcelTemplate="downloadExcelTemplate"
            @downloadExcelWareHouse="downloadExcelWareHouse"
            @downloadExcelWareHouseTransport="downloadExcelWareHouseTransport"
            @downloadDetails="downloadDetails"
            @downloadTemplate="downloadTemplate"
            @changeWareHouseType="changeWareHouseType"
          />
        </a-tab-pane>
        <a-tab-pane v-if="templateList.length" key="2" tab="自定义模板导入">
            <div v-if="isEnterprise" class="query_form_item">
              <a-form-model-item
                :rules="[{ required: true, message: '请选择服务商', trigger: 'change' }]"
                label="服务商"
                prop="tenantId"
              >
                <serviceSelect
                  :value="selectCarrier"
                  :is-default-select="true"
                  @change="handleChange"
                ></serviceSelect>
              </a-form-model-item>
            </div>
          <custom-multiple
            ref="customMultiple"
            :template-list="templateList"
            :form="templateForm"
            :transport-contract="transportContract"
            :product-flg="productFlg"
            :product-list="standardList"
            :is-customer-fill-in-contract-code.sync="isCustomerFillInContractCode"
            @downloadDetails="downloadDetails"
            @changeContract="handleChangeContract"
          />
        </a-tab-pane>
      </a-tabs>
      <li v-if="active==='2'&&fetchOrganization&&isCustomerFillInProject">
        <block-title title="选择项目">
          <div class="item-content widthStyle">
            <select-dom ref="projectRef" v-model="contractProjectForm.projectId" :default-select="false" :list.sync="projectList" @checkedList="checkedList" @onSearch="onSearchProject" />
            <div v-if="!projectALLData.length">
              暂无运营项目，请联系管理员创建
<!--              <a-button style="padding: 0" type="link" @click="toProject"-->
<!--              >创建运营项目</a-button>-->
            </div>
          </div>
        </block-title>
      </li>
      <!-- 选择合同及项目 active===1 -->
      <contractProject
      v-if="fetchOrganization&&active==='1'"
      :config="config"
      :project-list.sync="projectList"
      :project-a-l-l-data="projectALLData"
      :form="contractProjectForm"
      :contract-list="transportContract"
      :checked-list="checkedList"
      :on-search-project="onSearchProject"
      :to-project="toProject"
      @changeContract="handleChangeContract"
      @chargeType="handleChargeType"
      />
      <!-- 只在选择计划单配置过时显示 -->
      <template v-if="isOrderConfiged&&isWareHousePlanOrder">
        <li>
          <block-title v-if="fetchWarehouse" title="选择仓库">
            <div class="item-content widthStyle">
              <select-dom ref="warehouseRef" v-model="warehouseId" :list="warehouseList" @checkedList="handleCheckedWarehouse" @onSearch="onSearchWarehouse" />
              <div v-if="!warehouseAllList.length">
                暂无仓库
              </div>
            </div>
          </block-title>
        </li>
        <li>
          <block-title title="计划单备注">
            <div class="item-content widthStyle textArea_width">
              <a-textarea v-model="remark" :max-length="2000" placeholder="请输入计划单备注" :rows="4" />
            </div>
          </block-title>
        </li>
      </template>
      <li v-if="typeIndex === UPLOADTYPE.SPECIAL_TEMPLATE">
        <block-title title="是否合单">
          <div class="item-content widthStyle">
            <a-radio-group v-model="orderMerge" name="radioGroup">
              <a-radio :value="1"> 是 </a-radio>
              <a-radio :value="0"> 否 </a-radio>
            </a-radio-group>
          </div>
        </block-title>
      </li>
      <li>
        <block-title title="选择文件">
          <div class="item-content">
            <div class="content-upload">
              <a-upload
                :show-upload-list="false"
                :before-upload="beforeUpload"
                @change="handleFileChange"
              >
                <a-button
                  v-track-click="{
                    trackName: $route.query.menuName
                      ? `${$route.query.menuName}-批量导入下单-选择文件`
                      : `批量导入下单-选择文件`,
                  }"
                  class="uploadBtn"
                  :disabled="uploading || chooseTemplate"
                  type="primary"
                >
                  <img class="uploadStyle" src="@/assets/img/icon/upload.png" alt="" />
                  {{ selectFileBtnTxt }}
                </a-button>
              </a-upload>
            </div>
            <p class="upload-tip">
              单次上传最大不超过10000条数据，文件大小最大不超过10M，文件格式支持xlsx
            </p>
            <p v-if="file" class="filename">
              <img class="filenameLeft" src="@/assets/img/icon/icon_file.png" alt="" />
              {{ file.name }}
              <img
                class="filenameRight"
                src="@/assets/img/icon/icon_lajitong.png"
                alt=""
                @click="removeFile"
              />
            </p>
          </div>
        </block-title>
      </li>
      <li>
        <a-row>
          <a-col v-if="isParentMark" :span="8" >
            <a-form-model-item :colon="false" :label-col="{span: 6}" :wrapper-col="{span: 17}">
              <template #label>
                <div class="zimu_table">
                  <span>子母单标识</span>
                  <el-tooltip
                    content="非必填，相同子母单标识的订单，将合并计费"
                    placement="top"
                  >
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </div>
              </template>
                <a-select
                v-model="contractProjectForm.bdstNumber"
                show-search
                allow-clear
                :options="orderMarkList"
                placeholder="选择子母单标识"
              >
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
      </li>
    </ul>
     </a-form-model>
    <fix-bottom class="create-btns">
      <template slot="button">
        <a-button
          v-track-click="{
            trackName: $route.query.menuName
              ? `${$route.query.menuName}-批量导入下单-提交`
              : `批量导入下单-提交`,
          }"
          type="primary"
          :disabled="!file || showUploadProgress"
          :loading="uploading"
          @click="handleUpload"
          >提交</a-button
        >
      </template>
    </fix-bottom>
    <a-modal v-model="visible" title="提交成功">
      <p>请等待几分钟后前往任务跟踪导入结果</p>
      <template slot="footer">
        <a-button
          key="back"
          v-track-click="{ trackName: '导入成功-立即查看' }"
          @click="toTask"
        >
          立即查看
        </a-button>
        <a-button key="submit" type="primary" @click="visible = false"> 知道了 </a-button>
      </template>
    </a-modal>
    <!-- 模板下载 -->
    <a-modal v-model="downLoadModal" :footer="false" :mask-closable="false">
      <div class="proBox">
        <div class="icon_pic">
          <img src="@/assets/img/icon/pic_download.png" alt="" />
        </div>
        <p class="loadText">{{ downData.productName }}下单导入模板下载</p>
        <div class="progressStyle">
          <p class="progressTitle">正在{{ downData.productName }}模板</p>
          <a-progress
            :stroke-color="{
              from: '#108ee9',
              to: '#87d068',
            }"
            :percent="percent"
            status="active"
          />
        </div>
        <a-button key="submit" @click="downLoadModal = false"> 取消下载 </a-button>
        <p class="proTips">
          <img src="@/assets/img/icon/icon_notic_line.png" alt="" />
          <span>{{ downTips }}</span>
        </p>
      </div>
    </a-modal>
    <settlementModes ref="settlementModes" />
  </div>
</template>

<script>
import { getFileNameSuffix } from '@/utils/handleFile.js';
// import { EventBus } from "@/utils/event-bus";
import { getToken } from '@/utils/auth';
// import { getOrderRule } from '@/api/orderRules.js'
import SelectDom from '@/components/select/OrderSelect.vue';
import downloadField from '@/assets/img/icon/download_field.png';
import downloads from '@/assets/img/icon/download.png';
import BlockTitle from '@/components/panel/BlockTitle.vue';
import FixBottom from '@/components/fix-bottom/index.vue';
import serviceSelect from '@/components/selectCarrier/serviceSelect.vue';
import { handleCarrierData } from '@/utils/util';
import { getCredit } from '@/api/layout';
import { mapGetters,mapState,mapActions } from 'vuex';
import { ruleCropSensitive } from '@/api/orderRules'
import { getWareHouse } from '@/pages/warehouseOrder/api'
import {RULE_TYPE} from '@/constants/ruleConfig'
import settlementModes from '@/components/settlementModes/index.vue'
import Service from '../../../env/index.js';
import RuleMultiple from './components/RuleMultiple.vue'
import {
  importOrder,
  featchFailData,
  fetchProject,
  getInterface,
  importWareHouseOrder,
//  templateImport,
  getNonOperating,
  getWareHouseContract,
  getTemplateList,
  progress,
  importWareHouseMultiDischargeOrder,
  getConfig,
  customerCustomImport,
  getRules,
  getContract,
  parentMarkList
} from './api.js';
import StandardMultiple from './components/StandardMultiple.vue';
import NoStandardMultiple from './components/NoStandardMultiple.vue';
import WarehouseMultiple from './components/WarehouseMultiple.vue';
import CustomMultiple from './components/CustomMultiple.vue';
import { UPLOADTYPE, FILEURL, TEMPLATEURL, TEMPLATETYPE, WAREHOUSETYPE, UsualToBusiness } from './components/multipleConst'
import contractProject from './components/contractProject.vue';

const standardType = {
  CP001: 'CP001',
  CP002: 'CP002',
  CP003: 'CP003',
  CP004: 'CP004',
  SETTLEMENT_SEA_TRANSPORT: 'SETTLEMENT_SEA_TRANSPORT',
};
const skuDeleteStatus = 0; // 货品明细是否删除
const skuStatus = 1; // 货品明细状态
const wareHouseUploadType = ['WAREHOUSE_TRANSPORT','WAREHOUSE_ONLY','PLAN_ORDER','SETTLEMENT_SEA_TRANSPORT','MULTISTAGE_SETTLEMENT','SETTLEMENT_PRICE','SETTLEMENT']
export default {
  name: 'PlaceOrderMultiple',
  components: {
    SelectDom,
    BlockTitle,
    FixBottom,
    StandardMultiple,
    NoStandardMultiple,
    WarehouseMultiple,
    CustomMultiple,
    serviceSelect,
    RuleMultiple,
    contractProject,
    settlementModes,
  },
  data() {
    return {
      warehouseId: '', // 选择计划单时的数据
      remark: '', // 选择计划单时的数据
      warehouseAllList:[],
      warehouseList:[],
      fetchWarehouse:false,
      active: '1',
      UPLOADTYPE,
      // fileNameList,
      file: null,
      // 文件最大10M
      fileMaxSize: 1024 * 1024 * 10,
      // 文件类型暂时只支持 .xlsx
      fileTypeLimit: ['.xlsx','.xls'],
      // 上传进度
      uploadProgress: 0,
      showUploadProgress: false,
      uploadTip: '导入中，请耐心等待',
      uploading: false,
      uploadedData: null,
      sensitiveFields: [],
      typeIndex: UPLOADTYPE.SKU_CATEGORY,
      projectList: [],
      accountData: {},
      selectAll: true,
      projectALLData: [],
      orderMerge: 1,
      productFlg: true, // 是否有客户产品
      productList: [],
      TEMPLATETYPE,
      visible: false,
      isWarehouse: false, // 是否仓配下单
      WAREHOUSETYPE,
      downloadField,
      downloads,
      nonOperating: false,
      hasWarehouseContract: false,
      transportContract: [], // 非标合同
      standardList: [], // 标准合同
      templateForm: {
        templateCode: '', // 模板id
        // productId: '', // 合同id
      },
      templateList: [], // 自定义导入模板
      downLoadModal: false,
      downData: {},
      taskTime: null,
      taskTimer: null,
      percent: 0,
      downTips: '',
      isEnterprise: false,
      isOrderConfiged: false, // 是否有配置
      queryForm: {
        tenantId: '',
      },
      selectCarrier: '',
      showCreditTips: false,
      creditPercentage: 0,
      switchRatio: 0,
      isDischarge: false, // 一装多卸
      wareHouseType: WAREHOUSETYPE.STORE_V2,
      fetchOrganization: false,
      isProjectControl: false,
      projectTanantList: [],
      dischargeList: [],
      isSeaShipping: false, // 海运订单导入白名单
      seaShippingList: [], // 海运订单导入白名单列表
      isSupplementary: false, // 地上铁补录订单白名单
      supplementaryList: [], // 地上铁补录订单白名单列表
      isSettlement: false, // 自定义结算专用导入
      settlementList: [], // 自定义结算专用导入白名单
      orderRulesList:[],// 货主下单配置
      contractProjectForm:{
        chargeType:1
      }, // 合同项目表单
      orderMarkList:[], // 子母单列表
      isFirst: false,
    };
  },
  computed: {
    ...mapGetters('iframe', ['isWmsSystem']),
    ...mapState('orderRules', ['orderRules']),
    ...mapGetters('orderRules', ['isOrderDemoVersion']),
    isParentMark(){
      // 子母单标识
      const {PARENT_ORDER_MARK={}} = this.orderRules||{};
      const templateCodes = ['CP001','CP002','CP003','CP004' , 'ORDER_RULE']
      return templateCodes.includes(this.typeIndex)&&!!PARENT_ORDER_MARK.flag
    },
    creditMessage() {
      let message = '';
      if (this.creditPercentage >= 100) {
        message = '截至昨天您的回款已逾期，暂无法提交订单，请尽快处理!';
      } else {
        message = `截止昨天不包括在途的授信余额已占用${this.creditPercentage}%,请您及时进行回款操作，否则将有可能影响正常下单`;
      }
      return message;
    },
    showProject(){
      if(this.isOrderConfiged){
        // 配置过的纯运输按照配置显示运营项目
        if (this.typeIndex===WAREHOUSETYPE.ORDER_RULE ) {
          return this.isCustomerFillInProject;
        }
        return wareHouseUploadType.includes(this.typeIndex)
      }
      return true
    },
    isWareHousePlanOrder(){
      return this.typeIndex==='PLAN_ORDER';
    },
    creditType() {
      let type = '';
      if (this.creditPercentage >= 100) {
        type = 'error';
      } else {
        type = 'warning';
      }
      return type;
    },
    selectFileBtnTxt() {
      return !this.file ? '选择文件' : '重新选择';
    },
    getComponent() {
      // 下单规则配置
      if (this.isOrderConfiged){
        return RuleMultiple
      }
      // 仓产品
      // if (this.isWarehouse) {
      //   return WarehouseMultiple;
      // }
      // 标准产品
      if (this.productFlg) {
        return StandardMultiple;
      }
      // 非标产品
      return NoStandardMultiple;
    },
    // 选择项目显示
    showRroject() {
      let show = false;
      if (this.projectALLData.length) {
        if (this.active === '1') {
          if (this.typeIndex !== UPLOADTYPE.SPECIAL_TEMPLATE && !this.isWarehouse) {
            show = true;
          } else if (this.isWarehouse && this.isDischarge) {
            show = true;
          }
        } else {
          show = true;
        }
      }
      return show;
    },
    chooseTemplate() {
      if (this.active === '2' && !this.templateForm.templateCode) {
        return true;
      }
      return false;
    },
    isCustomerFillInProject(){
      // 自定义模板导入 项目信息是否需要客户手动填写
      const {ruleValue={}} = this.orderRulesList.find(item=>item.ruleCode ==='EMAIL_PROJECT')||{};
      if(!ruleValue||!ruleValue.name){
        return true
      }
      return ruleValue.name ==='CUSTOMER_INPUT'
    },
    isCustomerFillInContractCode(){
      // 自定义模板导入 项目信息是否需要客户手动填写
      const {ruleValue={}} = this.orderRulesList.find(item=>item.ruleCode ==='EMAIL_PRODUCT_CODE')||{};
       if(!ruleValue||!ruleValue.name){
        return true
      }
      return ruleValue.name ==='CUSTOMER_INPUT'
    },
    isSameContractTermCode(){
      // 查询项目绑定合同是否是当前选择合同
      return (e,data)=>{
        const productCodes = ['CP001','CP002','CP003','CP004']
        if(this.active==='1'&&productCodes.includes(this.typeIndex)){
           return e.operationResp?productCodes.includes(e.operationResp.productCode):true
        }if(e.operationContractResp&&e.operationContractResp.contractCode){
            return e.operationContractResp.contractCode===data.contractCode&&e.operationResp.termCode===data.contractTermCode
          }
        return true
      }
    },
    config(){
      if(!this.isOrderConfiged&&!this.isWarehouse&&!this.productFlg){
         // 非标
        return  {
          isContract:this.typeIndex!=='SPECIAL_TEMPLATE'&&this.wareHouseType !== WAREHOUSETYPE.DELIVER_ONLY_V2,
          isProject:this.showProject,
          isChargeType:this.typeIndex==='SETTLEMENT_PRICE',
        }
      }
      if(this.typeIndex==='ORDER_RULE'){
        // 纯运输
        return  {
          isContract:this.isCustomerFillInContractCode,
          isProject:this.showProject,
          isChargeType:this.typeIndex==='SETTLEMENT_PRICE',
        }
      }
      if(this.typeIndex==='WAREHOUSE_TRANSPORT'){
         // 仓配一体
        return  {
          isContract:true,
          isProject:this.showProject,
        }
      }
      if(this.isWarehouse||this.typeIndex===WAREHOUSETYPE.WAREHOUSE){
        // 仓
        return  {
          isContract:this.wareHouseType === WAREHOUSETYPE.STORE_V2,
          isProject:this.showProject,
        }
      }
      const templateTypes = ['SETTLEMENT_PRICE','WAREHOUSE_TRANSPORT','MULTISTAGE_SETTLEMENT']
      return  {
        isContract:templateTypes.includes(this.typeIndex),
        isProject:this.showProject,
        isChargeType:this.typeIndex==='SETTLEMENT_PRICE',
      }
    },
    isFillInContract(){
      return !(this.typeIndex === UPLOADTYPE.SETTLEMENT_PRICE&&this.contractProjectForm.chargeType===2)
    }
  },
  watch: {
    typeIndex() {
      if (this.typeIndex !== WAREHOUSETYPE.PLAN_FORMAL_ORDER) {
        this.projectList = [];
        this.projectALLData = [];
        this.getOrganization();
      }
    },
    selectCarrier(val){
      // this.getOrderRule();
      if(val){
        this.getSensitiveRule();
      }
    }
  },
  async created() {
    // 系统来源未WMS就不请求相关接口
    if (this.isWmsSystem) {
      this.isWarehouse = !!this.$route.query.type;
      this.typeIndex = WAREHOUSETYPE.PLAN_FORMAL_ORDER;
      return;
    }
    this.getProjectControl();
    this.getSeaShipping();
    this.getSettlement();
    this.getSupplementary();
    const { creditCode, customerId, customerCode,tenantName } = this.$store.state.user;
    this.isEnterprise = !!creditCode;
    this.selectCarrier = customerId;
    this.getWarehouseMultiDischarge();
    if (!creditCode) {
      await this.getOrderRules(RULE_TYPE.orderRules)
      this.getRulesList()
      this.isWarehouse = !!this.$route.query.type;
      this.accountData = JSON.parse(localStorage.getItem('accountData'));
      await this.getInterface();
      if (this.isWarehouse) {
        this.typeIndex = this.$route.query.type;
      }
      await this.getContract()
      this.getOrganization();
      if(this.isParentMark){
        // 子母单
        this.getParentMarkList()
      }
      this.getTemplateList();
    }
    if (this.isEnterprise) {
      this.getCredit();
    }
    // 如果是计划单
    if(!this.isEnterprise){
      this.getWareHouse([customerCode],tenantName)
    }
  },
  mounted() {},
  methods: {
    ...mapActions('orderRules', ['getOrderRules']),
    async getParentMarkList() {
      // 子母单列表获取
      const {tenantId, customerCode} = this.$store.state.user
      const res = await parentMarkList({
        customerCode,
        tenantId,
        statuses: ['ENABLE'],
      });
      if(res&&res.length){
        this.orderMarkList = res.map(item=>({value:item.code,label:item.code}))
      }else{
        this.orderMarkList = [];
      }
    },
    handleCheckedWarehouse(data){
      this.queryForm.warehouseTenantName = data.tenantName;
      this.queryForm.customerCode = data.shipperCode;
      this.queryForm.customerName = data.shipperName;
    },
    async getWareHouse( customerCodes = null, tenantName = null){
      this.fetchWarehouse = false
      const data = {
          customerCodes,
          tenantName,
          needExcludeDefaultTenant: true
      }
      try {
        const res = await getWareHouse(data,{size:500})
        if(res.length <= 0){
          this.warehouseList = []
          this.queryForm.warehouseId = '';
          this.handleCheckedWarehouse({})
          return
        }
        const wareList=[]
        res.records.forEach(item=>{
          if(!wareList.some(child=>child.tenantId===item.tenantId)){
            wareList.push(item)
          }
        })
        const arr = wareList.map((e) => {
          return {
              ...e,
              label: e.tenantName,
              value: e.tenantId
          }
        })
        // this.queryForm.warehouseId = arr[0].value;
        this.warehouseList = arr
        this.warehouseAllList = arr
        this.fetchWarehouse = true;
      } catch (error) {
        this.fetchWarehouse = false;
      }
    },
    onSearchWarehouse(value){
      this.warehouseList = this.warehouseAllList.filter((e) => {
        return e.label.includes(value)
      })
    },
    async getSensitiveRule(){
      const customers = this.$store.state.user?.customers || [];
      const customerReqs = [
        {
          customerCode: customers.find(e => e.customerId === this.selectCarrier)?.customerCode || this.$store.state.user?.customerCode,
          carrierTenantId: customers.find(e => e.customerId === this.selectCarrier)?.tenantId || this.$store.state.user?.tenantId,
        }
      ]
      const res = await ruleCropSensitive({customerReqs})
      this.sensitiveFields = res.result?.orderSensitiveFields || []
    },
    // getOrderRule(){
    //   if (!this.selectCarrier) return
    //   const customers = this.$store.state.user?.customers || [];
    //   const carrierTenantId = customers.find(e => e.customerId === this.selectCarrier)?.tenantId || this.$store.state.user?.tenantId;
    //   const customerCode = customers.find(e => e.customerId === this.selectCarrier)?.customerCode || this.$store.state.user?.customerCode;
    //   const params = {
    //     carrierTenantId,
    //     customerCode,
    //     processModuleCode: 'EMAIL_CREATE_ORDER',

    //   }
    //   getOrderRule(params).then(res =>{
    //     this.isOrderConfiged = !!res?.currentRules?.length;
    //     this.isWarehouse = !this.isOrderConfiged?this.isWarehouse:false
    //     this.typeIndex = WAREHOUSETYPE.ORDER_RULE;
    //   })
    // },
    async getRulesList(){
      const res =await getRules({
        customerCode: this.$store.state.user?.customerCode,
        carrierTenantId: this.$store.state.user?.tenantId,
        processModuleCode: 'EMAIL_CREATE_ORDER',
        configChannel:'PC_IMPORT',
      })
      this.isOrderConfiged = !!res?.currentRules?.length;
      // this.isWarehouse = !this.isOrderConfiged?this.isWarehouse:false
      if(!this.isWarehouse){
        this.typeIndex = WAREHOUSETYPE.ORDER_RULE;
      }
      this.orderRulesList = res.currentRules||[];
    },
    async getProjectControl() {
      const res = await getConfig({
        appId: '1004',
        keys: ['oms.project.control'],
      });
      this.projectTanantList = res.configs[0]?.value?.split(',');
      const tenantId = this.$store.state.user?.tenantId;
      this.isProjectControl = this.projectTanantList.includes(tenantId) || false;
    },
    async getSeaShipping() {
      const res = await getConfig({
        appId: '1004',
        keys: ['oms.sea.transport.import.customers'],
      });
      this.seaShippingList = res.configs[0]?.value?.split(',');
      const customerCode = this.$store.state.user?.customerCode;
      this.isSeaShipping = this.seaShippingList.includes(customerCode) || false;
    },
    async getSupplementary() {
      const res = await getConfig({
        appId: '1004',
        keys: ['oms.supplementary.import'],
      });
      this.supplementaryList = res.configs[0]?.value?.split(',');
      const customerCode = this.$store.state.user?.customerCode;
      this.isSupplementary = this.supplementaryList.includes(customerCode) || false;
    },
    async getSettlement() {
      const res = await getConfig({
        appId: '1004',
        keys: ['oms.settlement.transport.import'],
      });
      this.settlementList = res.configs[0]?.value?.split(',');
      const customerCode = this.$store.state.user?.customerCode;
      this.isSettlement = this.settlementList.includes(customerCode) || false;
    },
    toProject() {
      this.$router.push('/organization');
    },
    async getWarehouseMultiDischarge() {
      const res = await getConfig({
        appId: '1004',
        keys: ['oms.warehouse.multi.discharge'],
      });
      this.dischargeList = res.configs[0]?.value?.split(',');
      const customerCode = this.$store.state.user?.customerCode;
      this.isDischarge = !this.dischargeList.includes(customerCode);
    },
    async getCredit() {
      const { tenantId, customerCode } = this.$store.state.user;
      if (!customerCode && !tenantId) {
        return;
      }
      const res = await getCredit({
        customerCode,
        tenantId,
      });
      this.showCreditTips = res.warning;
      this.creditPercentage = ((res.proportion || 0) * 100).toFixed();
      this.switchRatio = ((res.switchRatio || 0) * 100).toFixed();
    },
    async handleChange(value) {
      const { customerCode, ownerTenantId } = value;
      this.contractProjectForm.projectId = '';
      this.contractProjectForm.projectName = '';
      this.parentId = '';
      this.isDischarge = !this.dischargeList.includes(customerCode);
      this.isSeaShipping = this.seaShippingList.includes(customerCode);
      this.isSettlement = this.settlementList.includes(customerCode);
      this.isSupplementary = this.supplementaryList.includes(customerCode);
      this.isProjectControl = this.projectTanantList.includes(ownerTenantId);
      this.isWarehouse = !!this.$route.query.type;
      this.queryForm.tenantId = value.ownerTenantId;
      this.nonOperating = false;
      this.projectALLData = [];
      this.selectCarrier = value.id;
      this.getRulesList()
      await this.getOrderRules(RULE_TYPE.orderRules)
      await this.getInterface()
      if (!this.isWarehouse) {
        // await this.getInterface();
        if (!this.isFirst) {
          this.typeIndex = this.$route.query.productType
        }
      }else if (!this.isFirst) {
        this.typeIndex = this.$route.query.type;
      }
      this.isFirst = true
      await this.getContract()
      if(this.isParentMark){
        // 子母单
        this.getParentMarkList()
      }
      await this.getOrganization();
      await this.getTemplateList();
      if (!this.templateList.length) {
        this.active = '1';
      }
      this.getCredit();
    },
    // 获取自定义模板
    async getTemplateList() {
      const res = await getTemplateList(
        {
          customerCodes: [this.$store.state.user.customerCode],
        },
        {
          size: 999,
          page: 1,
        }
      );
      const defaultTemplate = res.records.filter((item) => item.defaultTemplate)[0] || {};
      if(res.records&&res.records.length){
         this.templateList = res.records.map(item=>({...item,value:item.templateCode,label:item.templateName}))
      }else{
        this.templateList = [];
      }
      this.$set(this.templateForm,'templateCode',defaultTemplate.templateCode || '');
      this.$set(this.templateForm,'fileName',defaultTemplate.fileName || '');
      if(this.templateList.length){
        this.$set(this.templateForm,'templateCode',this.templateList[0]?.templateCode);
        this.$set(this.templateForm,'fileName',this.templateList[0]?.fileName);
        this.templateForm.fileUrl = this.templateList[0]?.fileUrl;
        this.$nextTick(()=>{
          if(this.$refs.customMultiple){
            this.$refs.customMultiple.changeTemplate(this.templateList[0]?.templateCode)
          }
        })
      }
    },
    removeFile() {
      this.file = null;
    },
    toTask() {
      if (this.isWmsSystem) {
        window.parent.postMessage({}, '*');
        this.visible = false;
        return;
      }
      this.$router.push('/task');
    },
    setContract(){
      const [contract={}] = this.transportContract||[];
      const [Term={}] =contract.contractTermInfo||[];
      this.$set(this.templateForm, 'contractCode', contract.contractCode)
      this.$set(this.templateForm, 'contractName', contract.contractName)
      this.$set(this.templateForm, 'contractTermCode', Term.code)
      this.$set(this.templateForm, 'contractTermName', Term.name)
      this.$set(this.contractProjectForm, 'contractCode', contract.contractCode)
      this.$set(this.contractProjectForm, 'contractName', contract.contractName)
      this.$set(this.contractProjectForm, 'contractTermCode', Term.code)
      this.$set(this.contractProjectForm, 'contractTermName', Term.name)
    },
    // setProduct(){
    //   const [item={}] = this.productList||[];
    //    this.$set(this.templateForm, 'product', item.productCode || '');
    //    this.$set(this.templateForm, 'productName', item.productName || '');
    // },
    async getContract (){
       const cargoOwnerCode = this.$store.state.user.customerCode;
       const transportContract = await getContract({
          cargoOwnerCode,
          status: 'ENABLED',
          needAllContracts: true,
        })
        this.transportContract = transportContract;
        this.setContract()
      },
    async getInterface() {
        const data =await  getInterface({})
        this.standardList = data;
        const res = JSON.parse(JSON.stringify(data));
        const cargoOwnerCode = this.$store.state.user.customerCode;
        const resdata = await getNonOperating({
          cargoOwnerCode,
        });
        if (resdata) {
          this.nonOperating = true;
        }
        this.getContract()
        const warehouseContract =await getWareHouseContract({
          cargoOwnerCode
        })
        const {  STORAGE = [] } = warehouseContract || {}
        if (res && res.length > 0) {
          this.productFlg = true;
          let arr = [];
          this.productList = [];
          const newArr = res.sort((a, b) => {
            return a.productCode.localeCompare(b.productCode);
          });
          if(!this.isOrderConfiged){
            this.typeIndex = newArr[0].productCode;
          }
          // 增加结算订单模板
          if (this.nonOperating) {
            newArr.push({
              contractCode: null,
              elements: '',
              negotiationType: '',
              productCode: 'SETTLEMENT',
              productName: '结算订单专用导入',
            });
            if (this.isSettlement) {
              newArr.push({
                contractCode: null,
                elements: '',
                negotiationType: '',
                productCode: 'SETTLEMENT_PRICE',
                productName: '结算订单专用导入',
                tips: '自定义应收应付',
                desc: '表格中填写货品品类，不填写sku明细',
              });
            }
          }

          if (this.isSeaShipping) {
            newArr.push({
              contractCode: 'SETTLEMENT_SEA_TRANSPORT',
              elements: '',
              negotiationType: '',
              productCode: 'SETTLEMENT_SEA_TRANSPORT',
              productName: '海运订单',
            });
          }
          if (this.isSupplementary) {
            newArr.push({
              contractCode: 'MULTISTAGE_SETTLEMENT',
              elements: '',
              negotiationType: '',
              productCode: 'MULTISTAGE_SETTLEMENT',
              productName: '补录订单导入专用',
            });
          }
          newArr.forEach((e, i) => {
            arr.push(e);
            if (arr.length >= 2) {
              this.productList.push(arr);
              arr = [];
            } else if (i === newArr.length - 1) {
              this.productList.push(arr);
            }
          })
        }else {
          this.productFlg = false;
          if(!this.isOrderConfiged){
            this.typeIndex = UPLOADTYPE.SKU_CATEGORY;
          }
        }
        if (STORAGE.length) {
          this.hasWarehouseContract = true;
        } else {
          this.hasWarehouseContract = false;
        }
    },
    onSearchProject(value) {
      this.selectAll = false;
      this.projectList = this.projectALLData.filter((e) => {
        return e.label.includes(value);
      });
    },
    checkedList(data) {
      this.contractProjectForm.projectName = data.name;
    },
    async getOrganization(value = null){
      this.fetchOrganization = false
      const {userId, customerCode} = this.$store.state.user
      const accountData = JSON.parse(localStorage.getItem('accountData'))
      let productCode = null;
      // if(!this.isWarehouse) {
      if (!this.isWarehouse && Object.keys(standardType).includes(this.typeIndex) && this.active === '1') {
        productCode = this.typeIndex
      }

      const data = {
        accountId: userId,
        relationType: 'DOWN',
        orgType: 'PROJECT',
        accountType: 'CUSTOMER',
        orgNameLike: value,
        // orgStatus: 'ENABLED',
        source: "OWN",
        relationOrgId:accountData?.id,
        customerCode,
        productCode,
        status:'ENABLE',

      }
      const res = await fetchProject(data)
      this.fetchOrganization = true
       if (res && res.length > 0) {
        const normalData=[];
        const disabledData=[];
        const records = res.map(t => ({
          ...t,
          name: t.projectName || t.name,
          code:t.projectCode||t.code
        }))
        records.forEach((e) => {
          let subLabel = ''
          if (e.operationResp?.termName) {
            subLabel = `${e.operationResp.termName}`
          }
          const item= {
            ...e,
            value: `${e.id}`,
            label: e.name,
            subLabel,
            disabled: !e.enableStatus||!this.setProjectDisabled(e,{contractCode:this.templateForm.contractCode,contractTermCode:this.templateForm.contractTermCode}),
            // disabled:false,
          }
           if(item.disabled){
            disabledData.push(item)
          }else{
            normalData.push(item)
          }
        })
         this.projectList=[...normalData,...disabledData]
      } else {
        this.projectList = []
      }
      this.projectALLData = this.projectList
      // }
    },
    // downloadTemplate() {
    //   window.location.href = `${Service.OSS_FILE_SERVER}${TEMPLATEURL.IMPORT_ORDER}`;
    // },
    setProjectDisabled(e,data){
      if(this.active==='2'){
        return this.isCustomerFillInContractCode?this.isSameContractTermCode(e,data):true
      }
      const templateCodes = ['SETTLEMENT_SEA_TRANSPORT','PLAN_ORDER','SPECIAL_TEMPLATE','SETTLEMENT']
      // 特殊类型的导入模板及纯仓出库以及结算订单专用选择一口价时不对项目进行过滤
      if(templateCodes.includes(this.typeIndex)||this.wareHouseType === WAREHOUSETYPE.DELIVER_ONLY_V2||(this.typeIndex==='SETTLEMENT_PRICE'&&this.contractProjectForm.chargeType===2)){
        return true
      }
      if(this.typeIndex==='ORDER_RULE'){
         return this.isCustomerFillInContractCode? this.isSameContractTermCode(e,{contractCode:this.contractProjectForm.contractCode,contractTermCode:this.contractProjectForm.contractTermCode}):true
      }
      return this.isSameContractTermCode(e,{contractCode:this.contractProjectForm.contractCode,contractTermCode:this.contractProjectForm.contractTermCode})
    },
    changeWareHouseType(type) {
      this.wareHouseType = type;
      this.getOrganization()
    },
    downloadGoods() {
      window.location.href = `${Service.OSS_FILE_SERVER}${TEMPLATEURL.CUS_TEMPLATEIMPORT_ORDER}`;
    },
    downloadSpecial() {
      window.location.href = `${Service.OSS_FILE_SERVER}${TEMPLATEURL.CUS_SPECIAL_IMPORT}`;
    },
    downloadExcelTemplate(item, type) {
      this.downData = item;
      // 仓配一体订单模板
      if (type === UPLOADTYPE.WAREHOUSE_TRANSPORT) {
        this.downLoadModal = true;
        this.downloadDetails(
          item.productName,
          TEMPLATEURL.WAREHOUSEONLY,
          type,
          null,
          true
        );
      } else {
        this.downloadDetails(item.productName, TEMPLATEURL.EXCEL_TEMPLATE, type);
      }
    },
    downloadExcelWareHouse(item, type) {
      this.downLoadModal = true;
      this.downloadDetails(item, TEMPLATEURL.WAREHOUSEONLY, type, null, true);
    },
    downloadExcelWareHouseTransport(item, type) {
      this.downLoadModal = true;
      if (type !== 'PLAN_ORDER') {
        if (this.isDischarge) {
          this.downloadDetails(item, TEMPLATEURL.WAREHOUSEDISCHARGE, type, null, true);
        } else {
          this.downloadDetails(item, TEMPLATEURL.WAREHOUSETRANSPORT, type, null, true);
        }
      } else {
        this.downloadDetails(item, TEMPLATEURL.PLAN_ORDER, type, null, true);
      }
    },
    downloadTemplate(item, type, isTransport) {
      this.downLoadModal = true;
      let url = TEMPLATEURL.WAREHOUSEDISCHARGEONLY;
      if (isTransport) {
        url = TEMPLATEURL.WAREHOUSEDISCHARGE;
      }
      this.downloadDetails(item, url, null, null, true, type);
    },
    beforeUpload(file) {
      this.file = file;
      this.validateFile(file);
      return false;
    },
    handleFileChange(fileInfo) {
      if (fileInfo?.file?.length !== 0) {
        this.showUploadProgress = false;
        this.uploadedData = null;
      }
    },
    changeTab(active) {
      this.active = active;
      this.getOrganization();
      if(Number(active)===2){
        this.getTemplateList();
      }
      // this.selectCarrier= this.queryForm.tenantId
    },
    async orderConfigUpload(){
      if(this.isWareHousePlanOrder){
        this.warehousePlanUpload();
        return
      }
      const warehouseType = ['WAREHOUSE_TRANSPORT','WAREHOUSE_ONLY']
      const isWarehouse = warehouseType.includes(this.typeIndex) // 模拟判断一下是否是仓导入直接带入之前的逻辑
       // 根据类型上传
      const { file } = this;
      const formData = new FormData();
      formData.append('file', file);
      this.uploading = true;
      this.showUploadProgress = true;
      const timer = this.fakeProgress();
      try {
        let resData = null;
        if (
          this.typeIndex === UPLOADTYPE.SETTLEMENT ||
          this.typeIndex === UPLOADTYPE.SETTLEMENT_PRICE ||
          this.typeIndex === UPLOADTYPE.WAREHOUSE_TRANSPORT
        ) {
          if(this.typeIndex === UPLOADTYPE.SETTLEMENT_PRICE&&this.contractProjectForm.chargeType===1){
            // 导入模板类型是结算订单专用模板导入(自定义应收应付) 且选择的计费方式是合同计费
            formData.append('needPrice', true);
          }
          formData.append('importScene', this.typeIndex);
        } else if (
          !isWarehouse &&
          this.typeIndex !== 'SETTLEMENT_SEA_TRANSPORT' &&
          this.typeIndex !== 'MULTISTAGE_SETTLEMENT'
        ) {
          formData.append('importScene', 'STANDARD_PRODUCT_V2' );  // this.isOrderConfiged为true   传STANDARD_PRODUCT_V2
          formData.append('product', this.typeIndex);
        } else {
          formData.append('importScene', this.typeIndex);
        }
        if(this.config.isContract&&this.contractProjectForm.contractCode&&this.isFillInContract){
          // 可以选择合同且有合同数据并且 (且选择的计费方式不是一口价)
          formData.append('contractCode',this.contractProjectForm.contractCode);
          formData.append('termCode',this.contractProjectForm.contractTermCode);
        }
        if(this.isParentMark){
          // 子母单
          formData.append('bdstNumber',this.contractProjectForm.bdstNumber);
        }
        if (!isWarehouse && this.typeIndex !== UPLOADTYPE.WAREHOUSE_TRANSPORT) {
          if (this.showProject&&this.contractProjectForm.projectId) {
            formData.append('projectId', this.contractProjectForm.projectId);
            formData.append('projectName', this.contractProjectForm.projectName);
          }
          if (this.accountData && this.accountData.id) {
            formData.append('parentId', this.accountData?.id);
          }
          formData.append('needMerge', this.orderMerge);
        }
        if (isWarehouse || this.typeIndex === UPLOADTYPE.WAREHOUSE_TRANSPORT) {
          if (
            this.isDischarge &&
            isWarehouse &&
            this.typeIndex !== WAREHOUSETYPE.PLAN_FORMAL_ORDER
          ) {
            if (this.showProject&&this.contractProjectForm.projectId) {
              formData.append('projectId', this.contractProjectForm.projectId);
              formData.append('projectName', this.contractProjectForm.projectName);
            }
            const importScene = this.isOrderDemoVersion?(this.wareHouseType):(UsualToBusiness[this.wareHouseType]||this.wareHouseType);
            // 纯仓
            // if (this.typeIndex === WAREHOUSETYPE.WAREHOUSE) {
            //   if (this.wareHouseType === WAREHOUSETYPE.STORE) {
            //     importScene = 'STORE_ONLY';
            //   } else {
            //     importScene = 'DELIVER_ONLY';
            //   }
            // } else if (this.wareHouseType === WAREHOUSETYPE.STORE) {
            //   importScene = 'STORE_TRANSPORT';
            // } else {
            //   importScene = 'DELIVER_TRANSPORT';
            // }

            formData.set('importScene', importScene);
            resData = await importWareHouseMultiDischargeOrder(formData);
          } else if (this.typeIndex === WAREHOUSETYPE.PLAN_FORMAL_ORDER) {
            // wms内嵌页面走这个接口
            resData = await importWareHouseMultiDischargeOrder(formData);
          } else {
            resData = await importWareHouseOrder(formData);
          }
        } else {
          resData = await importOrder(formData);
        }
        this.uploadedData = resData;
        this.visible = true;
        // EventBus.$emit("taskPopover");
      } catch (err) {
        this.showUploadProgress = false;
      } finally {
        this.uploading = false;
        this.uploadProgress = 100;
        this.file = null;
        clearInterval(timer);
      }
    },
    async handleUpload() {
      if(!this.typeIndex){
        // 未选择导入模板类型
         this.$message.warning('请选择导入类型');
         return
      }
      if(this.isOrderConfiged){
         // 如果显示项目选项就走之前验证是否必填的判断,否则不验证
        if (this.showProject&&this.isProjectControl && !this.contractProjectForm.projectId) {
          this.$message.warning('请选择项目');
          return;
        }
      }else if (this.isProjectControl && !this.contractProjectForm.projectId) {
          this.$message.warning('请选择项目');
          return;
        }
      // 根据类型上传
      const { file } = this;
      const formData = new FormData();
      formData.append('file', file);
      if(this.isOrderDemoVersion){
        // 当前货主属于在"货主端仓下单演示版本名单"内,在提交前弹窗选择结算方式
        await this.$refs.settlementModes.show()
      }
      this.uploading = true;
      this.showUploadProgress = true;
      const timer = this.fakeProgress();
      try {
        let resData = null;
        // 标准导入
        if (String(this.active) === '1') {
          if(this.isOrderConfiged){
            // 有配置
            this.orderConfigUpload()
            return
          }
          if(this.config.isContract&&this.contractProjectForm.contractCode&&this.isFillInContract){
            // 可以选择合同且有合同数据并且 (且选择的计费方式不是一口价)
            formData.append('contractCode',this.contractProjectForm.contractCode);
            formData.append('termCode',this.contractProjectForm.contractTermCode);
          }
          if(this.isParentMark){
            // 子母单
            formData.append('bdstNumber',this.contractProjectForm.bdstNumber);
          }
          if (
            this.typeIndex === UPLOADTYPE.SETTLEMENT ||
            this.typeIndex === UPLOADTYPE.SETTLEMENT_PRICE ||
            this.typeIndex === UPLOADTYPE.WAREHOUSE_TRANSPORT
          ) {
            if(this.typeIndex === UPLOADTYPE.SETTLEMENT_PRICE&&this.contractProjectForm.chargeType===1){
              // 导入模板类型是结算订单专用模板导入(自定义应收应付) 且选择的计费方式是合同计费
              formData.append('needPrice', true);
            }
            formData.append('importScene', this.typeIndex);
          } else if (
            this.productFlg &&
            !this.isWarehouse &&
            this.typeIndex !== 'SETTLEMENT_SEA_TRANSPORT' &&
            this.typeIndex !== 'MULTISTAGE_SETTLEMENT'
          ) {
            formData.append('importScene', this.isOrderConfiged ? 'STANDARD_PRODUCT_V2' : 'STANDARD_PRODUCT');
            formData.append('product', this.typeIndex);
          } else {
            formData.append('importScene', this.typeIndex);
          }
          if (this.showProject&&this.contractProjectForm.projectId) {
            formData.append('projectId', this.contractProjectForm.projectId);
            formData.append('projectName', this.contractProjectForm.projectName);
          }
          if (this.typeIndex !== UPLOADTYPE.WAREHOUSE_TRANSPORT) {
            if (this.accountData && this.accountData.id) {
              formData.append('parentId', this.accountData?.id);
            }
            formData.append('needMerge', this.orderMerge);
          }
          if (this.typeIndex === UPLOADTYPE.WAREHOUSE_ONLY || this.typeIndex === WAREHOUSETYPE.PLAN_FORMAL_ORDER || this.typeIndex === UPLOADTYPE.WAREHOUSE_TRANSPORT) {
            if (this.isDischarge && this.typeIndex !== WAREHOUSETYPE.PLAN_FORMAL_ORDER) {
              // if (this.showProject&&this.contractProjectForm.projectId) {
              //   formData.append('projectId', this.contractProjectForm.projectId);
              //   formData.append('projectName', this.contractProjectForm.projectName);
              // }
              // 有总裁版和业务版
              const importScene = this.isOrderDemoVersion?(this.wareHouseType):(UsualToBusiness[this.wareHouseType]||this.wareHouseType);
              // 纯仓
              // if (this.typeIndex === WAREHOUSETYPE.WAREHOUSE) {
              //   if (this.wareHouseType === WAREHOUSETYPE.STORE) {
              //     importScene = 'STORE_ONLY';
              //   } else {
              //     importScene = 'DELIVER_ONLY';
              //   }
              // } else if (this.wareHouseType === WAREHOUSETYPE.STORE) {
              //   importScene = 'STORE_TRANSPORT';
              // } else {
              //   importScene = 'DELIVER_TRANSPORT';
              // }

              formData.set('importScene', importScene);
              resData = await importWareHouseMultiDischargeOrder(formData);
            } else if (this.typeIndex === WAREHOUSETYPE.PLAN_FORMAL_ORDER) {
              // wms内嵌页面走这个接口
              resData = await importWareHouseMultiDischargeOrder(formData);
            } else {
              resData = await importWareHouseOrder(formData);
            }
          } else {
            resData = await importOrder(formData);
          }
        } else {
          // 自定义模板导入
          const { templateCode, contractCode, contractTermCode } = this.templateForm;
          // if(this.productFlg&&!product){
          //    this.$message.warning('运输产品不能为空');
          //   return;
          // }
          if (!this.productFlg&&(!contractCode||!contractTermCode)) {
            this.$message.warning('请选择合同条款');
            return;
          }
          formData.append("customTemplateCode", templateCode);
          // formData.append("product", product);
          if (contractCode&&this.isCustomerFillInContractCode) {
            formData.append("contractCode", contractCode);
          }
          if (contractTermCode&&this.isCustomerFillInContractCode) {
            formData.append("contractTermCode", contractTermCode);
          }
          if (this.contractProjectForm.projectId&&this.isCustomerFillInProject) {
            formData.append("projectId", this.contractProjectForm.projectId);
          }
          if (this.contractProjectForm.projectName&&this.isCustomerFillInProject) {
            formData.append("projectName", this.contractProjectForm.projectName);
          }
          // resData = await templateImport(formData)
          resData = await customerCustomImport(formData)
        }
        this.uploadedData = resData;
        this.visible = true;
        // EventBus.$emit("taskPopover");
      } catch (err) {
        this.showUploadProgress = false;
      } finally {
        this.uploading = false;
        this.uploadProgress = 100;
        this.file = null;
        clearInterval(timer);
      }
    },
    async downloadFailData() {
      const batchId = this.uploadedData?.batchId;
      try {
        const res = await featchFailData(batchId);
        // eslint-disable-next-line no-underscore-dangle
        if (window.__POWERED_BY_WUJIE__) {
          window.open(res[0].url)
        }else {
          window.location.href = res[0].url;
        }

      } catch (err) {
        console.error(err);
      }
    },
    validateFile(file) {
      const { fileMaxSize, fileTypeLimit } = this;
      const fileSize = file.size;
      const fileType = getFileNameSuffix(file.name);

      if (!fileTypeLimit.includes(fileType)) {
        this.file = null;
        this.$message.error('文件格式仅支持xlsx');
        return;
      }
      if (fileSize > fileMaxSize) {
        this.file = null;
        this.$message.error('文件最大不超过10M');
      }
    },
    fakeProgress() {
      this.uploadProgress = 0;
      const timer = setInterval(() => {
        if (this.uploadProgress >= 90) {
          clearInterval(timer);
          return;
        }
        this.uploadProgress += 1;
      }, Math.random() * 600);
      return timer;
    },
    editTypeIndex(index) {
      this.typeIndex = index;
      if(this.isOrderConfiged&&this.typeIndex==='PLAN_ORDER'){
        this.getWareHouse()
      }
    },
    downloadDetails(name, url, type = null, code = null, downLoadModal = false, scene) {
      const http = new XMLHttpRequest();
      const fromDate = {};
      if (type) {
        if (type === 'PLAN_ORDER') {
          fromDate.scene = type;
        } else {
          fromDate.templateType = type;
        }
      }
      if (scene) {
        fromDate.scene = this.isOrderDemoVersion?scene:(UsualToBusiness[scene]||scene);
      }
      // 自定义导入增加templateCode
      if (code) {
        fromDate.templateCode = code;
      }
      if (url === FILEURL.CUSTOMER_SKU_EXPORT) {
        fromDate.status = skuStatus;
        fromDate.deleteStatus = skuDeleteStatus;
      }
      if (downLoadModal) {
        this.taskTime = new Date().getTime();
        fromDate.progressId = this.taskTime;
        this.percent = 0;
        this.taskTimer = setInterval(this.progress, 100);
      }
      if (this.isDischarge && scene) {
        http.open('POST', `${Service.EXPORT_WEB}${url}`);
      } else if (type === 'PLAN_ORDER') {
        // wms内嵌页面模板下载
        http.open('POST', `${Service.EXPORT_WEB}${url}`);
      } else {
        http.open('POST', `${Service.OTMS_WEB_PLUS_SERVER}${url}`);
      }
      // http.open("POST", `http://10.250.0.95:8080/${url}`);
      http.responseType = 'blob';
      http.setRequestHeader('Authorization', getToken());
      http.setRequestHeader('Content-Type', 'application/json');
      if (handleCarrierData()) {
        const { isConvertEnterprise, enterpriseCustomer } = handleCarrierData();
        http.setRequestHeader('is_convert_enterprise', isConvertEnterprise);
        http.setRequestHeader('enterprise_customer', JSON.stringify(enterpriseCustomer));
      }
      http.onreadystatechange = () => {
        if (http.status === 200 && http.readyState === 4) {
          const filename = `${name}.xlsx`;
          const blob = new Blob([http.response], {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8',
          });
          const csvUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = csvUrl;
          link.download = filename;
          link.click();
        }
      };
      http.send(JSON.stringify(fromDate));
    },
    progress() {
      progress({
        progressId: this.taskTime,
      }).then((res) => {
        this.percent = res.currentProgress;
        this.downTips = res.tips;
        if (res.currentProgress === 100) {
          clearInterval(this.taskTimer);
          this.downLoadModal = false;
        }
      });
    },
    isVaildate (){
      if(!this.contractProjectForm.projectId){
        this.$message.warning('请选择项目')
        return false
      }
      if(!this.warehouseId){
        this.$message.warning('请选择仓库')
        return false
      }
      return true
    },
    async warehousePlanUpload() {
      const {warehouseTenantName,customerCode,customerName} = this.queryForm;
      if (!this.isVaildate()) return
      // 根据类型上传
      const { file } = this;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("importScene", 'PLAN_AUDIT_ORDER');
      formData.append("projectId", this.contractProjectForm.projectId);
      formData.append("projectName", this.contractProjectForm.projectName);
      formData.append("customerCodeAndName", `${customerName}--${customerCode}`);
      formData.append("warehouseCodeAndName", `${warehouseTenantName}--${this.warehouseId}`);
      if(this.remark){
        formData.append('remark',this.remark)
      }
      this.uploading = true;
      this.showUploadProgress = true;
      const timer = this.fakeProgress();
      try {
        const resData = await importWareHouseMultiDischargeOrder(formData)
        this.uploadedData = resData;
        this.visible = true
      } catch (err) {
        this.showUploadProgress = false;
      } finally {
        this.uploading = false;
        this.uploadProgress = 100;
        this.file = null
        this.queryForm.remark =undefined;
        clearInterval(timer);
      }
    },
    handleChangeContract(data){
      this.contractProjectForm.contractCode = data.contractCode
      this.contractProjectForm.contractTermCode = data.contractTermCode
      this.contractProjectForm.contractName = data.contractName
      this.contractProjectForm.contractTermName = data.contractTermName
      this.getOrganization()
    },
    handleChargeType(){
      this.getOrganization()
    }
  },
};
</script>

<style lang="less">
.PlaceOrderMultiple-root {
  // padding: 32px 0;
  height: 100%;
  margin-bottom: 100px;
  background-color: @base-bg-color;
  border-radius: 6px;
  .credit-content {
    position: fixed;
    z-index: 200;
    width: 100%;
    left: 0;
    top: 8px;
  }
  .credit-tips {
    height: 48px;
    line-height: 48px;
    padding: 0 16px;
    width: 422px;
    background: #fff;
    border: none;
    box-shadow: 0px 7px 12px 1px rgb(126 126 126 / 15%);
    border-radius: 4px;
    margin: auto;
    margin-bottom: 16px;
    .ant-alert-icon {
      top: 0;
    }
    .ant-alert-message {
      margin-left: 24px;
      font-size: 14px;
    }
    .ant-alert-close-icon {
      top: 13px;
    }
    &.ant-alert-warning {
      width: 300px;
      .ant-alert-message {
        color: #fe5e08;
      }
      .ant-alert-icon {
        color: #ff9200;
      }
    }
    &.ant-alert-error {
      width: 40%;
      .ant-alert-message {
        color: #ed4934;
      }
      .ant-alert-icon {
        color: #ed4934;
      }
    }
  }
  .operation-item {
    margin-top: 28px;

    &:first-child {
      margin-top: 0;
    }
    .exportStyle {
      width: 80%;
      // padding-left: 32px;
      box-sizing: border-box;
    }
    .mar {
      margin-top: 25px;
    }
  }
  .item-label {
    color: #000;
    font-size: 16px;
    font-weight: bold;
    position: relative;
    padding-left: 5px;
    margin-bottom: 20px;
    padding-top: 20px;
    &::after {
      content: '';
      position: absolute;
      left: -30px;
      top: 22px;
      border-radius: 2px;
      background-color: #06b880;
      width: 4px;
      height: 16px;
    }
  }
  .item-content {
    margin-left: 32px;
    padding: 24px 0;
  }
  .btn-link {
    padding: 0;
  }
  .filename {
    width: 536px;
    height: 64px;
    margin-top: 32px;
    border-radius: 4px;
    border: 1px solid #e7e9ec;
    font-size: 14px;
    color: #171717;
    line-height: 64px;
    padding: 0 20px 0 27px;
    .filenameLeft {
      margin-right: 28px;
    }
    .filenameRight {
      float: right;
      margin-top: 23px;
      &:hover {
        cursor: pointer;
      }
    }
  }
  .upload-tip {
    margin-top: 16px;
    color: #a9abae;
    font-size: 12px;
  }
  .upload-progress {
    margin-top: 25px;
  }
  .progress-tip {
    margin-top: 8px;
    color: #666;
    font-size: 14px;
  }
  .error {
    color: #ff4830;
  }

  .operation-footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 74px;
  }
  /deep/ .ant-checkbox-inner {
    border-radius: 50% !important;
  }
  .ant-checkbox-checked::after {
    border-radius: 50% !important;
  }
  .radioBox {
    border: 1px solid rgb(235, 232, 232);
    padding: 40px;
    border-radius: 6px;
    background-color: #f4f5f6;
    &:hover {
      cursor: pointer;
      background: #ffffff;
      box-shadow: 0px 18px 19px 0px rgba(207, 232, 224, 0.78);
      border-radius: 6px;
      border: 1px solid #06b880;
      .exportTitle {
        color: #000;
        font-weight: bold;
      }
      .skuStyle {
        color: #7d7b7b;
        span {
          color: #06b880;
        }
      }
      // .batchBtnStyle {
      //   background: #f2fbf8;
      //   color: #06b880;
      //   border-radius: 4px;
      //   border: 1px dashed #ebe8e8;
      // }
    }
    .exportTitle {
      color: #000;
      font-size: 14px;
      font-size: 22px;
      line-height: 33px;
      font-weight: bold;
    }
    .skuStyle {
      font-size: 12px;
      color: #bebcbc;
      padding: 10px 0 20px 0;
      line-height: 16px;
      span {
        font-size: 14px;
        color: #06b88071;
        float: right;
      }
    }
    .batchBtnStyle {
      padding: 10px;
      background: #f2fbf8;
      color: #606266;
      border-radius: 4px;
      border: 1px dashed #ebe8e8;
      .icon_load {
        float: right;
        margin-top: 12px;
      }
      &.isActive {
        border: 1px dashed #06b880;
      }
    }
  }
  .radioBoxActive {
    position: relative;
    background: #ffffff;
    box-shadow: 0px 18px 19px 0px rgba(207, 232, 224, 0.78);
    border-radius: 6px;
    border: 1px solid #06b880;
    .exportTitle {
      color: #000;
      font-weight: bold;
    }
    .skuStyle {
      color: #7d7b7b;
      span {
        color: #06b880;
      }
    }
    // .batchBtnStyle {
    //   background: #f2fbf8;
    //   color: #06b880;
    //   border-radius: 4px;
    //   border: 1px dashed #ebe8e8;
    // }
  }
  .leftStyle {
    margin-left: 20px;
  }
  .product-flg {
    margin-top: 25px;
    margin-left: 0;
    &:nth-of-type(2n + 1) {
      margin-right: 20px;
    }
  }
  .widthStyle {
    width: 456px;
  }
  .activeImg {
    position: absolute;
    top: 0px;
    right: 0px;
  }
  .uploadStyle {
    margin-right: 12px;
    vertical-align: bottom;
  }
  .uploadBtn {
    padding: 6px 36px;
  }
  .create-btns {
    .align-right {
      .ant-btn {
        height: 48px;
        width: 120px;
        &.ant-btn-primary {
          width: 280px;
        }
      }
    }
  }
}
.proBox {
  padding: 0 20px;
  text-align: center;
  .icon_pic {
    text-align: center;
  }
  .loadText {
    font-size: 18px;
    text-align: center;
    color: #171717;
    font-weight: bold;
  }
  .progressStyle {
    margin-bottom: 36px;
    .progressTitle {
      font-size: 14px;
      color: #909399;
      text-align: center;
      margin-top: 32px;
    }
  }
  .proTips {
    color: #909399;
    font-size: 14px;
    margin-top: 40px;
    span {
      vertical-align: text-top;
    }
    img {
      vertical-align: sub;
      margin-right: 8px;
    }
  }
}
</style>
<style lang="less" scoped>
.query_form {
  .query_form_item {
    margin: 24px 0px;
    /deep/.ant-form-item-label {
      width: 120px;
    }
    /deep/.ant-form-item-control-wrapper {
      display: inline-flex;
      .ant-form-item-control {
        min-width: 350px;
      }
    }
  }
}
.zimu_table{
  margin-right: 4px;
}
</style>
